import FalconCardHeader from 'components/common/FalconCardHeader';
import React, { useState } from 'react';
import firebase from './../../../../firebase';
import { Button, Card, Form } from 'react-bootstrap';

import { toast } from 'react-toastify';


const ChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    oldPassword: null,
    newPassword: null,
    confirmPassword: null
  });

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (formData && formData.oldPassword && formData.newPassword){

      if (formData.newPassword === formData.confirmPassword){
        const user = firebase.auth().currentUser;

        const { email } = user;
    
        const credential = firebase.auth.EmailAuthProvider.credential(
          email,
          formData.oldPassword
        );
        setLoading(true);
        // console.log("test",formData )
            try {
              await user.reauthenticateWithCredential(credential);
              try {
                await user.updatePassword(formData.newPassword);
                toast.success('Mot de passe modifié.');
                setLoading(false);
              } catch (error) {
                console.log(error)
                setLoading(false);
                toast.error('Une erreur s\'est produite.');
              } 
            } catch (error) {
              setLoading(false);
              console.log(error.code)
              toast.error('Le mot de passe n\'est pas correct.');
            }
      }else{
        toast.error('Les nouveaux de passe ne correspondent pas.');
      }
      

    }else{
      toast.error('Veuillez remplir tout les champs.');
    }

    



  };

  return (
    <Card className="mb-3">
      <FalconCardHeader title="Changer le  mot de passe" />
      <Card.Body className="bg-body-tertiary">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="oldPassword">
            <Form.Label>Mot de passe actuel</Form.Label>
            <Form.Control
              type="password"
              value={formData.oldPassword}
              name="oldPassword"
              onChange={handleChange}
              minLength={6}

            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="newPassword">
            <Form.Label>Nouveau mot de passe</Form.Label>
            <Form.Control
              type="password"
              value={formData.newPassword}
              name="newPassword"
              onChange={handleChange}
              minLength={6}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="confirmPassword">
            <Form.Label>Confirmer le mot de passe</Form.Label>
            <Form.Control
              type="password"
              value={formData.confirmPassword}
              name="confirmPassword"
              onChange={handleChange}
              minLength={6}
            />
          </Form.Group>
          <Button className="w-100" type="submit" disabled={loading}>
          {!loading ? 'Mise à jour du mot de passe': 'Chargement'}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default ChangePassword;
